import React, { useEffect, useState } from 'react';
import { fetchOrders } from '../api/airtable';
import '../styles/App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';

const ReturnedItems = ({ userRole, carNumber, username, pageTitle }) => {
    const [returnedItems, setReturnedItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [checkedItems, setCheckedItems] = useState({});

    useEffect(() => {
        const getReturnedItems = async () => {
            let allOrders = await fetchOrders();
            const returnedStatuses = ["ไม่ส่ง", "ไม่รับ", "ไม่ตอบ", "ไม่รับเลื่อนส่ง"];
            const now = new Date();
            const currentHours = now.getHours();
            let targetDate = now.toLocaleDateString("th-TH");

            if (currentHours >= 0 && currentHours < 4) {
                const yesterday = new Date();
                yesterday.setDate(now.getDate() - 1);
                targetDate = yesterday.toLocaleDateString("th-TH");
            }
    
            const filteredItems = allOrders
                .filter(order => {
                    const orderDate = new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH");
                    const isStatusMatched = returnedStatuses.includes(order.fields['สถานะ']);
                    const isTodayOrYesterday = orderDate === targetDate;

                    const isCarMatched = String(order.fields['เบอร์รถ']).trim() === String(carNumber).trim();

                    
                    

                    return isStatusMatched && isTodayOrYesterday && isCarMatched;
                })
                .map(order => ({
                    queue: order.fields['ลำดับส่ง'] || 'N/A',
                    customerName: order.fields['ชื่อออเดอร์'].split('-')[0],

                    orderId: order.id,
                    orderNumber: order.fields['เลขที่ออเดอร์'],
                    products: order.fields['รายการสินค้า'] ? order.fields['รายการสินค้า'].split('\n') : [],
                }));

            


    
            // ตั้งค่าให้กับ state
            setReturnedItems(filteredItems);
            setIsLoading(false);
        };
    
        getReturnedItems();
    }, [carNumber]);
    

    const handleCheckboxChange = (orderId, productIndex) => {
        setCheckedItems(prevState => ({
            ...prevState,
            [orderId]: {
                ...prevState[orderId],
                [productIndex]: !prevState[orderId]?.[productIndex],
            }
        }));
    };

    return (
        <div>
            <header className="page-header">
                <h1>{`${pageTitle} รถเบอร์ ${carNumber}`}</h1>
            </header>
            {isLoading ? (
                <div className="load-orders-message-container">
                    <FontAwesomeIcon icon={faBoxOpen} className="load-orders-icon load-orders-paper" />
                    <p className="load-orders-message">กำลังโหลดรายการของเหลือ...</p>
                </div>
            ) : (
                <div className="returned-items-list">
                    {returnedItems.length > 0 ? (
                        returnedItems.map((item, index) => (
                            <div key={index} className="returned-item">
                                <h3>คิว {item.queue} - ออเดอร์ #{item.orderNumber}</h3>
                                <p>ลูกค้า {item.customerName}</p>

                                <ul>
                                    {item.products.map((product, idx) => (
                                        <li key={idx}>
                                            <input
                                                type="checkbox"
                                                checked={checkedItems[item.orderId]?.[idx] || false}
                                                onChange={() => handleCheckboxChange(item.orderId, idx)}
                                            />
                                            <label>{product}</label>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                    ) : (
                        <p className="no-orders-message">ไม่มีของเหลือกลับร้าน</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ReturnedItems;
